"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _Divider = require("../Divider");

var _TemplateMessageInsertTag = require("./TemplateMessageInsertTag.styles");

/**
 * @typedef TemplateTag
 * @property {string} placeholder
 * @property {string} label
 * @property {string} [value='']
 */

/**
 * TemplateMessageInsertTag.
 *
 * @param {object} props
 * @param {React.RefObject} props.inputRef
 * @param {function (string): void} props.onInsert
 * @param {Array<TemplateTag>} props.tags
 * @param props.disabled
 * @returns {React.ReactNode}
 * @example
 * import { TextField } from '@mui/material';
 * export const Editor = () => {
 *    const [value, setValue] = useState('');
 *    const inputRef = useRef();
 *    const tags = [
 *      { placeholder: '{contact-name}', value: 'Benedikt', label: 'Contact name' }
 *    ];
 *    const onInsertTag = useCallback(
 *      tag => {
 *        const { selectionStart, selectionEnd, value: refValue } = textFieldRef.current;
 *        const firstPart = refValue.substring(0, selectionStart);
 *        const lastPart = refValue.slice(selectionEnd, refValue.length);
 *
 *        setValue(`${firstPart}${tag}${lastPart}`);
 *
 *        setTimeout(() => {
 *          textFieldRef.current.selectionStart = selectionStart + tag.length;
 *          textFieldRef.current.selectionEnd = selectionEnd + tag.length;
 *          textFieldRef.current.focus();
 *         }, 0);
 *       },
 *     [onChange],
 *   );
 *   const handleChange = useCallback(
 *     event => {
 *       setValue(event.currentTarget.value)
 *     },
 *     []
 *   )
 *   return (
 *     <TemplateMessageInsertTag inputRef={textFieldRef} onInsert={onInsertTag} tags={tags} />
 *     <TextField ref={inputRef} value={value} onChange={handleChange} />
 *   );
 * }
 */
var TemplateMessageInsertTag = function TemplateMessageInsertTag(_ref) {
  var inputRef = _ref.inputRef,
      onInsert = _ref.onInsert,
      tags = _ref.tags,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var classes = (0, _TemplateMessageInsertTag.useStyles)();

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var anchorOrigin = (0, _react.useMemo)(function () {
    return {
      vertical: 'bottom',
      horizontal: 'right'
    };
  }, []);
  var transformOrigin = (0, _react.useMemo)(function () {
    return {
      vertical: 'top',
      horizontal: 'right'
    };
  }, []);
  var onOpen = (0, _react.useCallback)(function (_ref2) {
    var currentTarget = _ref2.currentTarget;

    if (disabled) {
      return;
    }

    setAnchorEl(currentTarget);
    inputRef.current.focus();
  }, [inputRef, disabled]);
  var onClose = (0, _react.useCallback)(function () {
    setAnchorEl(null);
  }, []);
  var onTagLabelClick = (0, _react.useCallback)(function (tag) {
    if (disabled) {
      return;
    }

    onInsert(tag);
    onClose();
  }, [disabled, onInsert, onClose]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    pb: 1
  }, /*#__PURE__*/_react["default"].createElement(_material.ButtonBase, {
    disabled: disabled,
    disableRipple: true,
    onClick: onOpen,
    className: "Body-Small-Link"
  }, "+Insert custom data")), /*#__PURE__*/_react["default"].createElement(_material.Popover, {
    onClose: onClose,
    open: !!anchorEl,
    anchorEl: anchorEl,
    anchorOrigin: anchorOrigin,
    transformOrigin: transformOrigin,
    classes: (0, _react.useMemo)(function () {
      return {
        paper: classes.arrow
      };
    }, [classes])
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    className: classes.popoverRoot,
    component: _material.Box,
    px: 2,
    flexWrap: "wrap",
    display: "flex",
    width: 350,
    maxHeight: 476,
    borderColor: "divider",
    boxShadow: "0 2px 16px 0 rgba(0, 0, 0, 0.12)"
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: "Label-Table-Left-Static"
  }, "FIELD")), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: "Label-Table-Left-Static"
  }, "PREVIEW")), /*#__PURE__*/_react["default"].createElement(_Divider.Divider, {
    mb: 2
  }), tags.map(function (tag) {
    return /*#__PURE__*/_react["default"].createElement(_material.Box, {
      display: "flex",
      width: 1,
      mb: 2,
      key: tag.placeholder
    }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/_react["default"].createElement(_material.ButtonBase, {
      disableRipple: true,
      onClick: function onClick() {
        return onTagLabelClick(tag);
      },
      "data-value": tag.value,
      className: "Body-Regular-Left-Link-Bold"
    }, tag.label)), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: 6,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }, tag.value || tag.property));
  }))));
};

TemplateMessageInsertTag.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  inputRef: _propTypes["default"].object.isRequired,
  disabled: _propTypes["default"].bool,
  onInsert: _propTypes["default"].func.isRequired,
  tags: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    placeholder: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].string
  })).isRequired
};
TemplateMessageInsertTag.defaultProps = {
  disabled: false
};

var _default = /*#__PURE__*/(0, _react.memo)(TemplateMessageInsertTag);

exports["default"] = _default;